import gql from 'graphql-tag';

import { PhotoUrlTypeFields } from '../../../../apps/consumer/graphql/fragments/global';
import { PhotoForegroundDetails } from '../../../../graphql/fragments/photo';

const getAccountCardConfigurationPhotosQuery = gql`
  query getAccountCardConfigurationPhotos(
    $limit: Int = 40
    $matchesOffset: Int = 0
    $favoritesOffset: Int = 0
    $entitledOffset: Int = 0
    $identity_ids: [RecordID]
    $album_folder_id: RecordID
    $hierarchy_item_id: RecordID
    $album_ids: [RecordID]
  ) {
    me {
      id
      matched_photos(
        slice: { limit: $limit, offset: $matchesOffset }
        identity_ids: $identity_ids
        album_folder_id: $album_folder_id
        album_ids: $album_ids
      ) {
        total
        records {
          id
          thumbnail_urls(ignore_watermark: true) {
            ...PhotoUrlTypeFields
          }
          ...PhotoForegroundDetails
          faces {
            total
          }
        }
      }
      entitled_matched_photos(
        slice: { limit: $limit, offset: $matchesOffset }
      ) {
        total
        records {
          id
          photo {
            id
            thumbnail_urls(ignore_watermark: true) {
              ...PhotoUrlTypeFields
            }
            ...PhotoForegroundDetails
          }
        }
      }
      entitled_photos(
        slice: { limit: $limit, offset: $entitledOffset }
        identity_ids: $identity_ids
        hierarchy_item_id: $hierarchy_item_id
      ) {
        total
        records {
          id
          thumbnail_urls(ignore_watermark: true) {
            ...PhotoUrlTypeFields
          }
          ...PhotoForegroundDetails
        }
      }
      favorited_photos(slice: { limit: $limit, offset: $favoritesOffset }) {
        total
        records {
          id
          thumbnail_urls(ignore_watermark: true) {
            ...PhotoUrlTypeFields
          }
          ...PhotoForegroundDetails
        }
      }
    }
  }
  ${PhotoUrlTypeFields}
  ${PhotoForegroundDetails}
`;

export default getAccountCardConfigurationPhotosQuery;
